module.exports = __webpack_public_path__ + "static/img/poster_1.15a55f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_10/poster_1.jpg
// module id = EYd5
// module chunks = 0